<template>
	<div class="incenters TableBox">
		<!-- style="border: 1px solid red;" -->
		<div>
			<!-- <Commonbtn title="导出"></Commonbtn> -->
			<div class="topstate" v-for="(item , index) of state" :key="index+'title'"
				:class="[{ 'ativte' : onchage == index}]" @click="clicktab(index)">
				{{ item.title }}
			</div>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth" v-if="tableflag" style="overflow-x: scroll;">
			<Commontable :rowhe="false" colnum=7 :loadingTable="loadingTable" :tableData="tableDataDetail"
				:headerData="headerData" height="100%"></Commontable>
		</div>
		<div class="TableWidth" v-if="tableflags">
			<Commontable colnum=7 :tableData="tableDataUnique" :loadingTable="loadingTable" :headerData="headerData1"
				height="100%"></Commontable>
		</div>
	</div>
</template>

<script>
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import {
		wmsDespatchDetail,
		wmsDespatchDetailUnique

	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,

		},
		props: ['dpmid', 'tableDataUnique', 'tableDataDetail'],
		data: function() {
			return {
				loadingTable: false,
				state: [{
						title: '明细'
					},
					{
						title: '唯一码'
					}
				],
				headerData1: [{
						prop: 'id',
						label: '序号',
						columnwidth: 120
					},
					{
						prop: 'InvAddCode',
						label: '商品代码',
						columnwidth: 120
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 260
					},
					{
						prop: 'InvUniqueCode',
						label: '唯一码',
						columnwidth: 450
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 450
					},
				],
				tableData1: [],
				tableData: [],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 60
					},
					{
						prop: 'InvAddCode',
						label: '商品代码',
						columnwidth: 170
					},
					{
						prop: 'InvName',
						label: '存货名称',
						columnwidth: 160
					},
					{
						prop: 'Batch',
						label: '批号',
						columnwidth: 160
					},
					{
						prop: 'ValiDate',
						label: '有效期至',
						columnwidth: 160
					},
					{
						prop: 'Quantity',
						label: '数量',
						columnwidth: 60
					},
					// {
					// 	prop: 'VouDCode',
					// 	label: '来源单据表体单号',
					// 	columnwidth: 160
					// },
					{
						prop: 'TaxUnitPrice',
						label: '原币含税单价',
						columnwidth: 105
					},
					{
						prop: 'TaxRate',
						label: '税率',
						columnwidth: 53
					},
					{
						prop: 'ExchangeRate',
						label: '汇率',
						columnwidth: 53
					},
					{
						prop: 'UnitPrice',
						label: '原币单价',
						columnwidth: 105
					},
					{
						prop: 'Money',
						label: '原币金额',
						columnwidth: 105
					},
					{
						prop: 'TaxPrice',
						label: '原币税额',
						columnwidth: 105
					},
					{
						prop: 'Sum',
						label: '原币价税合计',
						columnwidth: 105
					},
					{
						prop: 'Money',
						label: '原币金额',
						columnwidth: 105
					},
					{
						prop: 'NatSum',
						label: '本币价税合计',
						columnwidth: 105
					},
					{
						prop: 'NatMoney',
						label: '本币金额',
						columnwidth: 105
					},
					{
						prop: 'NatTaxPrice',
						label: '本币税额',
						columnwidth: 105
					},
					{
						prop: 'InvoiceNo',
						label: '发票号',
						columnwidth: 150
					},
					{
						prop: 'BillQuantity',
						label: '开票数量',
						columnwidth: 82
					},
					{
						prop: 'CorVCode',
						label: '退货单号',
						columnwidth: 82
					},
					{
						prop: 'BackQuantity',
						label: '退货数量',
						columnwidth: 82
					},
					{
						prop: "DetailRemark1",
						label: "明细备注1",
						columnwidth: 160,
					},
					{
						prop: "DetailRemark2",
						label: "明细备注2",
						columnwidth: 160,
					},
					{
						prop: "DetailRemark3",
						label: "明细备注3",
						columnwidth: 160,
					},
					{
						prop: "DetailRemark4",
						label: "明细备注4",
						columnwidth: 160,
					},
					{
						prop: "DetailRemark5",
						label: "明细备注5",
						columnwidth: 160,
					},
					{
						prop: "InvUniqueCode",
						label: "唯一码",
						columnwidth: 160,
					},
				],
				onchage: 0,
				tableflag: true,
				tableflags: false,
			}
		},
		created() {},
		mounted() {},
		methods: {
			// 明细
			async wmsDespatchDetail() {
				let {
					data,
					code
				} = await wmsDespatchDetail({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			// 唯一码
			async wmsDespatchDetailUnique() {
				let {
					data,
					code
				} = await wmsDespatchDetailUnique({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			clicktab(index) {
				if (index == 0) {
					this.tableflag = true
					this.tableflags = false
					this.wmsDespatchDetail()
				}
				if (index == 1) {
					this.tableflag = false
					this.tableflags = true
					this.wmsDespatchDetailUnique()
				}
				if (this.onchage != index) {
					this.onchage = index
				}
				this.$emit('clicktab', index)
			}
		}
	}
</script>

<style lang="less" scoped>
	.ativte {
		border: 1px solid red;
		color: #e71d43;
		background-color: #fce8ec;
		transition: 0.2s linear;
	}

	.incenters {
		height: 100%;
		font-family: "微软雅黑";
		background-color: #fff;
		width: 980px;
		margin-top: 10px;
		padding-bottom: 10px;
		padding-top: 2px;

		div {
			margin-left: 8px;
			margin-right: 8px;
			margin-top: 5px;
			margin-bottom: 5px;
			// width: 100%;
		}
	}

	.topstate {
		width: 100px;
		height: 32px;
		font-size: 14px;
		border: 1px solid #e6e6e6;
		line-height: 32px;
		text-align: center;
		cursor: pointer;
		display: inline-block;
		user-select: none;
	}
</style>